<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.motivos"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                <template v-if="item.ciap">
                    {{`${item.ciap.codigo} - ${item.ciap.descricao}`}}
                </template>
            </template>

            <template v-slot:cell(cid)="{item}">
                <template v-if="item.cid">
                    {{`${item.cid.codigo} - ${item.cid.nome}`}}
                </template>
            </template>

            <template v-slot:cell(observacao)="{index, item}">
                <rkm-button
                    :id="uniqueId(`observacao-${index}`)"
                    small
                >
                    <rkm-icon icon="comment"/>
                </rkm-button>

                <rkm-popover
                    :target="uniqueId(`observacao-${index}`)"
                    triggers="hover"
                    placement="top"
                >
                    {{item.observacao}}
                </rkm-popover>
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {key: 'cid', label: 'CID 10', sortable: true},
            {key: 'observacao', label: 'Observação'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o motivo do atendimento?', async () => {
                this.data.model.motivos.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>